import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures SPA navigation behaves like normal page loads.
 * Without this, React Router keeps the previous scroll position,
 * which can look like a redirect to the footer.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // If there's a hash, let the browser/other logic handle anchor scrolling.
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, search, hash]);

  return null;
}
